<main>

    <mat-sidenav-container [class.opened]="opened">
        <mat-sidenav #sidenav mode="side" [(opened)]="opened" class="main-container" [class.mobile-open]="mobileOpen">
            <ostso-side-bar-double
                [titleCreate]="''"
                (toggle)="sidenav.toggle()"
                [opened]="sidenav.opened"
                (clickOutside)="onClickOutside()"
                (createNew)="onCreateNew()"
            />
        </mat-sidenav>

        <mat-sidenav-content>
            <section class="section">
                <div class="grade-head">
                    <ostso-register-header (open)="mobileOpen=true"/>
                    <div class="header-title">
                        <div class="state">{{ isNew ? 'Создание оценки' : gradeStatus?.name }}</div>
                        <div class="grade-for">
                            @if (isNew) {
                                <div>{{ currentUser()?.department?.name || currentUser()?.organization?.name }}</div>
                            } @else {
                                <div>{{ grade()?.user?.departmentName || grade()?.user?.organizationName }}</div>
                            }
                            <!--              <pre>{{ grade()?.user | json}}</pre>-->

                            @if (isNew && currentUser()) {
                                <div>{{ currentUser()?.lastName }} {{ currentUser()?.firstName && currentUser()?.firstName?.[0] }}
                                    . {{ currentUser()?.middleName && currentUser()?.middleName?.[0] }}
                                    .
                                </div>
                            }
                            @if (!isNew) {
                                <div>{{ grade()?.user?.lastName }} {{ grade()?.user?.firstName && grade()?.user?.firstName?.[0] }}
                                    . {{ grade()?.user?.middleName && grade()?.user?.middleName?.[0] }}
                                    .
                                </div>
                            }

                        </div>
                    </div>
                    <div class="header-filter">
                        <mat-icon class="grade-icon"
                                  svgIcon="pas-icon-change"
                                  (click)="onStatusSelect()"
                                  pasAccessRole="status"
                                  [mode]="mode()"
                        >

                        </mat-icon>
                        <mat-icon class="grade-icon" svgIcon="pas-icon-delete"
                                  pasAccessRole="archive"
                                  [mode]="mode()"
                                  (click)="onArchive()"></mat-icon>
                        <mat-icon class="grade-icon" svgIcon="pas-icon-attach_file_add"
                                  (click)="onCopyURL()"></mat-icon>
                        @if (canEmailView()) {
                            <mat-icon class="grade-icon"
                                      [class.disabled]="!canEmailClick()"
                                      [class.green]="wasEmailSent()"
                                      (click)="onEmail()"
                            >
                                email
                            </mat-icon>
                        }
                        <mat-icon class="grade-icon" (click)="onClose()">close</mat-icon>
                    </div>


                </div>
                <div class="create-grade" [attr.data-enabled]="enterData()">
                    <form class="create-grade__initial-params" [formGroup]="formParams">
                        <!-- Выбор Учреждения -->
                        <pas-experiment
                            pasAccessRole="organization"
                            [mode]="mode()"
                            [items]="organizations$| async"
                            [formControlName]="'organization'"
                            [placeholder]="'Выберите учреждение'"
                        >
                            <ng-template #itemView let-item let-active="active">
                                <div class="item-view"
                                     [class.active]="active">{{ item['name'] || 'Учреждение или объект' }}
                                </div>
                            </ng-template>
                        </pas-experiment>

                        <!-- Дата создания -->
                        <div [attr.data-enabled]="isNew && (isDepartment() || isOrganization()) ? false : true">
                            <mat-form-field
                                pasAccessRole="date"
                                [mode]="mode()"
                                class="create-grade__control create-grade__organization"
                                [class.error]="createAt && createAt.touched && createAt.invalid"
                                appearance="fill"
                            >
                                <input matInput [matDatepicker]="pickerFrom" [formControlName]="'createAt'"
                                       placeholder="Дата создания оценки">
                                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                                <mat-datepicker #pickerFrom></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <!-- Выбор типа оценки и года-->
                        <div class="create-grade__options create-grade__control">
                            <!-- Выбор типа оценки -->
                            <div class="create-grade__option"
                                 pasAccessRole="period"
                                 [mode]="mode()"
                            >
                                <div class="create-grade__label">Тип оценки</div>
                                <div class="create-grade__buttons">
                                    @for (item of periods$ | async; track item.id) {
                                        <button
                                            class="create-grade__button"
                                            [class.active]="period && item.id === period.id"
                                            (click)="period=item"
                                        >{{ item.name }}
                                        </button>
                                    }
                                </div>
                            </div>
                            <!-- Выбор года-->
                            <div class="create-grade__option"
                                 pasAccessRole="year"
                                 [mode]="mode()"
                            >
                                <div class="create-grade__label">Выбор года</div>
                                <div class="create-grade__buttons">
                                    @for (item of years; track item.id) {
                                        <button
                                            class="create-grade__button"
                                            [class.active]="year && item.id === year.id"
                                            (click)="year=item"
                                        >{{ item.name }}
                                        </button>
                                    }
                                </div>
                            </div>

                            <!-- Выбор квартала-->
                            @if (period && period.name === 'Квартальная') {
                                <div class="create-grade__option"
                                     id="quarters"
                                     pasAccessRole="quarter"
                                     [mode]="mode()"
                                >
                                    <div class="create-grade__label">Квартал</div>
                                    <div class="create-grade__buttons">
                                        @for (item of quarters; track item.id) {
                                            <button
                                                class="create-grade__button"
                                                [class.active]="quarter && item.id === quarter.id"
                                                (click)="quarter=item"
                                            >{{ item.name }} квартал
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>

                        <!-- Комментарий -->
                        <mat-form-field
                            pasAccessRole="grade_comment"
                            [mode]="mode()"
                            class="create-grade__control create-grade__organization"
                            appearance="fill"
                        >
                            <input matInput [formControlName]="'comment'" placeholder="Комментарий">
                        </mat-form-field>

                    </form>
                </div>
                <form [formGroup]="formValue" class="create-grade__value">

                    <!-- Список объектов -->
                    <pas-experiment
                        pasAccessRole="org_facility_indices"
                        [mode]="mode()"
                        [items]="structuredObject()"
                        [formControlName]="'object'"
                        [placeholder]="'Выберите оценку по учреждению/объекту'"
                    >
                        <ng-template #itemView let-item let-active="active">
                            <div class="option" [class.active]="active">
                                @if (!item) {
                                    <span>Выберите оценку по учреждению/объекту</span>
                                } @else {
                                    <div class="item-container">
                                        @if (item.type === 'Facility') {
                                            @if (canCheckboxView()) {
                                                <input class="need-check-analytic"
                                                       type="checkbox"
                                                       [checked]="item['needCheckAnalytic']"
                                                       (click)="onCheckAnalytic(item, $event)"
                                                       [disabled]="!canCheckboxEdit()|| mode() === 'view'"
                                                />
                                            }
                                        }
                                        @if (item.type === 'Facility') {
                                            {{ item.entity.name }} / {{ item.entity.address ?? 'адрес не указан' }}
                                        } @else {
                                            {{ item.entity.name }}
                                        }
                                    </div>
                                    @if (isFilled(item)) {
                                        <mat-icon svgIcon="pas-icon-true"></mat-icon>
                                    } @else {
                                        <mat-icon svgIcon="pas-icon-false"></mat-icon>
                                    }
                                }
                            </div>
                        </ng-template>
                    </pas-experiment>
                </form>

                <pas-grade-fill-form
                    class="create-grade__fill-form"
                    [canUpload]="canUploadValues()"
                    (uploadExcel)="onUploadExcel($event)"
                    [uploading]="isUploadingExcel"
                    pasAccessRole="indicator_indices"
                    [mode]="mode()"
                    [busy]="isGettingExcelFile"
                    [object]="formValue.get('object')?.value ?? null"
                    [stage]="stage"
                    (enterData)="onEnterData($event)"
                    (exportExcel)="onExportExcel($event)"
                    (noViolations)="onNoViolations()"
                />

                <div class="controls">
                    @for (b of controlButtons(); track b.title) {
                        <button class="btn btn-limit"
                                (click)="b.event()"
                                [pasAccessRole]="b.name"
                                [mode]="mode()"
                                [blockator]="b.blockator && b?.blockator()"
                                [class.btn-grey]="!b.blue && !b.red"
                                [class.btn-blue]="b.blue"
                                [class.btn-red]="b.red"
                                [disabled]="isAppling() || (b.name==='save' && !structuredObject().length)"
                        >
                            {{ b.title }}
                        </button>
                    }
                </div>

            </section>
        </mat-sidenav-content>
    </mat-sidenav-container>


</main>

